import Splide from '@splidejs/splide';

export default function Sliders() {
	// --- CTA Slider ---
	const ctaSlider = document.querySelector('.js-cta-slider');
	ctaSlider && new Splide('.js-cta-slider', {
		type: 'fade',     // Allows infinite looping of slides
		arrows: false,     // Display navigation arrows
		pagination: false, // Hide pagination dots
		keyboard: false,   // Disable keyboard navigation
		drag: false,       // Enable slide dragging with mouse
		rewind: true,     // If end is reached, rewind to the start
		autoplay: true,    // Slides will transition automatically
		speed: 1000,      // Transition speed in milliseconds
		interval: 5000,   // Autoplay interval (5 seconds)
		pauseOnHover: false, // Continue autoplay even on hover
		pauseOnFocus: false, // Continue autoplay even on focus
	}).mount();


	// --- Banner Slider ---
	const caseStudyElements = document.querySelectorAll('.js-case-study-slider');

	if (caseStudyElements.length) {
		for (let i = 0; i < caseStudyElements.length; i++) {
			new Splide(caseStudyElements[i], {
				type: 'loop',     // Allows infinite looping of slides
				arrows: false,     // Display navigation arrows
				pagination: false, // Hide pagination dots
				keyboard: false,   // Disable keyboard navigation
				drag: true,       // Enable slide dragging with mouse
				rewind: true,     // If end is reached, rewind to the start
				autoplay: true,    // Slides will transition automatically
				speed: 1000,      // Transition speed in milliseconds
				interval: 5000,   // Autoplay interval (5 seconds)
				pauseOnHover: false, // Continue autoplay even on hover
				snap: true,         // Force move to the closest slide on drag end
				autoHeight: true, // Adjust slider height based on the active slide
				gap: 40
			}).mount();
		}
	}


	// --- Logos Slider ---
	const logosElements = document.querySelector('.js-logo-slider');
	logosElements && new Splide('.js-logo-slider', {
		type: 'loop',     // Allows infinite looping of slides
		perPage: 2,       // Display 1 slide per page on mobile
		perMove: 2,       // Number of slides moved on "next" or "prev"
		gap: 40,   // Increase gap for this breakpoint
		pagination: false, // Hide pagination dots
		arrows: false,     // Hide navigation arrows
		mediaQuery: 'min', // Use min-width in breakpoint calculations
		autoplay: true,    // Slides will transition automatically
		speed: 1000,      // Transition speed in milliseconds
		interval: 5000,   // Autoplay interval (5 seconds)
		breakpoints: {
			767: {
				perPage: 3, // Display 3 slides per page on tablets
			},
			1023: {
				perPage: 4, // Display 4 slides per page on larger tablets
			},
			1279: {
				perPage: 6, // Display 6 slides per page on desktops
			},
		},
	}).mount();


	// --- Product Feed Sliders ---
	const productFeed = document.querySelectorAll('.js-product-slider');
	for (let i = 0; i < productFeed.length; i++) {
		new Splide(productFeed[i], {
			type: 'slide',     // Standard sliding without loop or fade
			perPage: 1,       // Display 1 slide per page on mobile
			perMove: 1,       // Number of slides moved on "next" or "prev"
			gap: 20,           // Gap between slides in pixels
			pagination: false, // Hide pagination dots
			arrows: true,      // Display navigation arrows
			mediaQuery: 'min', // Use min-width in breakpoint calculations
			autoplay: false,    // Slides won't transition automatically
			breakpoints: {
				767: {
					perPage: 2, // Display 2 slides per page on tablets
				},
				1023: {
					perPage: 3, // Display 3 slides per page on larger tablets
				},
				1279: {
					perPage: 5, // Display 5 slides per page on desktops
				},
			},
			classes: {
				arrows: 'splide__arrows',
				arrow: 'splide__arrow',
				prev: 'splide__arrow--prev',
				next: 'splide__arrow--next',
			},
		}).mount();
	}


	// --- Gallery Sliders ---
	const gallery = document.querySelectorAll('.js-gallery-slider');
	for (let i = 0; i < gallery.length; i++) {
		new Splide(gallery[i], {
			type: 'loop',     // Standard sliding without loop or fade
			perPage: 1,       // Display 1 slide per page on mobile
			perMove: 1,       // Number of slides moved on "next" or "prev"
			gap: 20,           // Gap between slides in pixels
			pagination: true, // Hide pagination dots
			arrows: false,      // Display navigation arrows
			mediaQuery: 'min', // Use min-width in breakpoint calculations
			autoplay: false,    // Slides won't transition automatically
			classes: {
				pagination: 'splide__pagination u-dots',
				page: 'splide__pagination__page u-dots__item',
			},
			breakpoints: {
				767: {
					perPage: 2, // Display 2 slides per page on tablets
				},
				1023: {
					perPage: 3, // Display 3 slides per page on larger tablets
				},
			},
		}).mount();
	}
}
